import {
  CHANGE_SCRIPT_DATA, DELETE_SCRIPT_DATA, DELIVERY_METHOD,
  GET_PATIENT_SCRIPTS, GET_SCRIPT_ATTACHMENTS,
  GET_SCRIPT_PAYMENTS,
  GET_SCRIPT_STATUS,
  GET_SCRIPTS,
  GET_SCRIPTS_NOTES, POSTAL_SERVICES_DATA,
  SCRIPT_NOTE_OR_ATTACHMENT_IDS, SET_SCROLLING_TO_NOTE, US_POSTAL_RESPONSE,
} from '../actions/script';

const initialState = {
  scriptData: [],
  scriptTotalPage: 1,
  patientScriptData: [],
  patientScriptTotalPage: 1,
  requestStatus: '',
  scriptNotes: [],
  notesRequestStatus: '',
  scrollingToNoteId: null,
  scriptNoteOrAttachmentDataIds: [],
  notesId: [],
  attachmentsId: [],
  scriptStatuses: [],
  scriptPayments: [],
  scriptAttachment: [],
  scheduleDeliveryMethod: '',
  usPostalResponseData: [],
  postalServicesData: {},
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_SCRIPTS.SUCCESS: {
      return {
        ...state,
        scriptData: payload.data.response,
        scriptTotalPage: payload.data._meta.pageCount,
        requestStatus: 'success',
      };
    }

    case GET_SCRIPTS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_PATIENT_SCRIPTS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_PATIENT_SCRIPTS.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        patientScriptData: payload.data.response,
        patientScriptTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_SCRIPTS_NOTES.REQUEST: {
      return {
        ...state,
        scriptNotes: [],
        notesRequestStatus: 'request',
      };
    }

    case GET_SCRIPTS_NOTES.SUCCESS: {
      return {
        ...state,
        notesRequestStatus: 'success',
        scriptNotes: payload.data.response,
      };
    }

    case SCRIPT_NOTE_OR_ATTACHMENT_IDS: {
      return {
        ...state,
        attachmentsId: payload.name === 'attachment' ? payload.ids : [],
        notesId: payload.name === 'note' ? payload.ids : [],
      };
    }

    case CHANGE_SCRIPT_DATA: {
      return {
        ...state,
        patientScriptData: state.patientScriptData.map((p) => (p.id === payload.id
          ? { ...p, [payload.name]: payload.value }
          : p)),
      };
    }

    case DELETE_SCRIPT_DATA: {
      return {
        ...state,
        patientScriptData: state.patientScriptData.filter((p) => (p.id !== payload)),
      };
    }

    case GET_SCRIPT_STATUS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_SCRIPT_STATUS.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        scriptStatuses: payload.data.response.reverse(),
      };
    }

    case GET_SCRIPT_PAYMENTS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_SCRIPT_PAYMENTS.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        scriptPayments: payload.data.response,
      };
    }

    case GET_SCRIPT_ATTACHMENTS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_SCRIPT_ATTACHMENTS.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        scriptAttachment: payload.data.response,
      };
    }

    case SET_SCROLLING_TO_NOTE: {
      return {
        ...state,
        scrollingToNoteId: payload,
      };
    }

    case DELIVERY_METHOD: {
      return {
        ...state,
        scheduleDeliveryMethod: payload,
      };
    }

    case US_POSTAL_RESPONSE.SUCCESS: {
      return {
        ...state,
        usPostalResponseData: payload.data.data,
      };
    }

    case POSTAL_SERVICES_DATA: {
      return {
        ...state,
        postalServicesData: payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
